import React from 'react'
import PropTypes from 'prop-types'
import { Text, TouchableHighlight, View } from 'react-native'
import { Icon } from 'react-native-elements'
import styles, { colors } from '../../styles'
import panelStyles from '../../styles/panel'
import { trackEventAndNavigate } from '../../actions/helpers'
import { displayTelephoneLine } from '../methods/RegionalContentLookUp'
import { checkHyphenation } from '../../utils'

const buttonStyle = {
  justifyContent: 'center',
  marginTop: 16,
  paddingVertical: 16,
  width: '100%',
}

const connectionButtonStyles = [
  buttonStyle,
  styles.arrowButton,
  panelStyles.elevatedContainer,
  panelStyles.cardRounding,
  panelStyles.cardShadow,
]

const outlineVisible = {
  borderWidth: 1,
  borderColor: colors.raven_grey50,
}

const getTelephoneLineSection = (t, locale, outline) => {
  let objToReturn
  if (displayTelephoneLine(locale)) {
    objToReturn = (
      <View style={styles.needHelpContainer}>
        <TouchableHighlight
          style={[connectionButtonStyles, (outline ? outlineVisible : null)]}
          onPress={() => trackEventAndNavigate('LandlineSetup1Page', 'landline')}
          accessible
          accessibilityLabel={t('access:landLinkButton')}
          testID="standard-telephone-line-btn"
          underlayColor="#ddd"
        >
          <>
            <View style={styles.communicatorSetupButtonTextView}>
              <Text
                style={styles.communicatorSetupButtonText}
              >
                {checkHyphenation(t('common:standardTelephone'))}
              </Text>
            </View>
            <Icon name="chevron-right" type="material-community" size={24} color={colors.shark_grey} />
          </>
        </TouchableHighlight>
      </View>
    )
  }
  return objToReturn
}

function ConnectionOptions(props) {
  const {
    t, locale, outline, testID,
  } = props

  return (
    <>
      <View style={styles.needHelpContainer} testID={testID}>
        <TouchableHighlight
          style={[connectionButtonStyles, (outline ? outlineVisible : null)]}
          onPress={() => trackEventAndNavigate('USBCellularStep1Page', 'cellular')}
          accessible
          accessibilityLabel={t('access:usbCellularButton')}
          testID="usb-cellular-btn"
          underlayColor="#ddd"
        >
          <>
            <View style={styles.communicatorSetupButtonTextView}>
              <Text
                style={styles.communicatorSetupButtonText}
              >
                {checkHyphenation(t('common:usbCellularAdapter'))}
              </Text>
            </View>
            <Icon name="chevron-right" type="material-community" size={24} color={colors.shark_grey} />
          </>
        </TouchableHighlight>
      </View>
      {getTelephoneLineSection(t, locale, outline)}
      <View style={styles.needHelpContainer}>
        <TouchableHighlight
          style={[connectionButtonStyles, (outline ? outlineVisible : null)]}
          onPress={() => trackEventAndNavigate('USBEthernetStep1Page', 'ethernet')}
          accessible
          accessibilityLabel={t('access:usbEthernetButton')}
          testID="usb-ethernet-btn"
          underlayColor="#ddd"
        >
          <>
            <View style={styles.communicatorSetupButtonTextView}>
              <Text
                style={styles.communicatorSetupButtonText}
              >
                {checkHyphenation(t('common:usbEthernetAdapter'))}
              </Text>
            </View>
            <Icon name="chevron-right" type="material-community" size={24} color={colors.shark_grey} />
          </>
        </TouchableHighlight>
      </View>
    </>
  )
}

ConnectionOptions.propTypes = {
  t: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  outline: PropTypes.bool,
  testID: PropTypes.string.isRequired,
}

ConnectionOptions.defaultProps = {
  outline: false,
}

export default ConnectionOptions
